<template>
     <div class="success-boxs fix">
       <div class="left-column"><img src="../assets/no_order.jpg" alt="商品已失效"></div>
       <div class="panel">
         <h4 class="title"><span>很抱歉，您查看的商品已失效。</span></h4>
         <div class="option" >
           {{time}}秒后将会跳转到 【<router-link :to="`/${merchantCode}`">积分商城</router-link>】
          </div>
         
         <z-button size='icon-query' @click='yes()'>返回积分商城</z-button>
      
      </div>
    </div>
</template>
<script>
import ZButton from "./zButton";
let interval
export default {
  components: {
    ZButton
  },

  data() {
    return {
      merchantCode: "",
      isDisabled: false,
			time: 10
    };
  },
  created() {
    let oUrls = this.$route.path;
    this.merchantCode = oUrls.substring(
      oUrls.indexOf("/") + 9,
      oUrls.lastIndexOf("/")
    );
    // this.$store.dispatch("SHOPINFO", this.$route.params.id)
    this.outData();
  },
  destroyed (){
    window.clearInterval(interval);
  },
  methods: {
    yes() {
      this.$router.push(`/${this.merchantCode}`);
    },
    outData() {
      let me = this;
      me.isDisabled = true;
      interval = window.setInterval(function() {
        --me.time;
        if (me.time < 0) {
          me.$router.push(`/${me.merchantCode}`);
          me.time = 0;
          me.isDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
    }
  }
};
</script>
<style>
.success-boxs {
  padding: 100px;
  margin: 0 auto;
  width: 1200px;
  text-align: center;
}
.success-boxs .left-column {
  width: 550px;
  margin-right: 50px;
  height: 200px;
  text-align: right;
  float: left;
}
.success-boxs .panel {
  float: left;
  width: 412px;
  color: #333;
  text-align: left;
}
.success-boxs .panel .title {
  font-size: 16px;
  line-height: 26px;
  margin-top: 30px;
  color: #666;
}

.success-boxs .option {
  padding: 10px 0 30px;
}
.success-boxs .option a {
  color: #f60;
}
.success-boxs strong {
  color: #e42900;
  font-weight: 700;
}
</style>
